export default {
	/**
	 * init post Title screenreader labels
	 */
	init() {
		[...this.$el.getElementsByClassName('post--headline')].forEach(post => {
			const $elementHeadline = post.querySelector('.element--headline');
			if ($elementHeadline) {
				post.setAttribute('aria-label', $elementHeadline.textContent);
			}
			post.setAttribute('role', 'text');
			post.setAttribute('tabindex', 0);
		});
	},
	destroy() {},
};
